var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2788 1.50056C26.8717 2.83465 26.8717 4.99763 25.2788 6.33172C23.6859 7.6658 21.1032 7.6658 19.5103 6.33172C17.9173 4.99763 17.9173 2.83465 19.5103 1.50056C21.1032 0.166479 23.6859 0.166479 25.2788 1.50056Z",
    fill: "#4ED372"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M9.87244 26.9751H14.4613",
    stroke: "#4ED372",
    strokeWidth: 2.19609,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3949 12.4564V27.829C22.3949 29.7164 20.5695 31.2451 18.3159 31.2451H6.07897C3.82534 31.2451 2 29.7164 2 27.829V7.33215C2 5.44474 3.82534 3.91602 6.07897 3.91602H12.1974",
    stroke: "#4ED372",
    strokeWidth: 2.19609,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertPhoneIcon);
export default __webpack_public_path__ + "static/media/alert-phone-icon.9f90cd1e25e76416b6fb6baaa6af70fc.svg";
export { ForwardRef as ReactComponent };